module.exports = __webpack_public_path__ + "media/images/custom_page/bae173_event2/bae173-event-ko-2440b163704a86b6d2c0a7c2a6fb9f8a.png";